

















































































































import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';

// Components
import Loading from '@/components/Global/Loading.vue';
import Alert from '@/components/Global/Alert.vue';
import Welcome from '@/components/Global/Welcome.vue';

@Component({
	name: 'ManageUsers',
	components: {
		Loading,
		Alert,
		Welcome,
	},
})
export default class ManageUsers extends Vue {
	@State('members', { namespace: 'OrgAdmin' }) private members: any;
	@State('invites', { namespace: 'OrgAdmin' }) private invitees: any;
	@Action('getAdminAccounts', { namespace: 'OrgAdmin' }) private getAdminAccounts: any;
	private error: boolean = false;
	private loading: boolean = true;
	private noUsers: boolean = false;
	private tab: string = 'users';

	get userOrAgent() {
		if (this.$store.state.Auth === undefined) {
			return '';
		}

		if (
			this.$store.state.Auth.user.isAgent === 'true' &&
			this.$store.state.Auth.user.isOrgAdmin === 'true'
		) {
			return 'Agent';
		}

		return 'User';
	}

	private openMember(subId) {
		this.$router.push({
			name: 'org_manageuser',
			params: {
				subId,
			},
		});
	}

	private openInvite(email) {
		this.$router.push({
			name: 'org_manageemail',
			params: {
				email,
			},
		});
	}

	private created() {
		this.getAdminAccounts()
			.catch(e => {
				console.log(e);
				this.error = true;
			})
			.finally(() => {
				this.loading = false;
			});
	}
}
